import { NotifyHelper } from "../../../helpers/toast";
import { eMucThuActionsObj } from "../../action-types/muc-thu/IMucThuActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const mucThuActions = {
  ...generateActions(eMucThuActionsObj, "MUC_THU"),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "CREATE_MUCTHUKHAC_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "CREATE_MUCTHUKHAC_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "DELETE_MUCTHUKHAC_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "DELETE_MUCTHUKHAC_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "UPDATE_MUCTHUKHAC_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "UPDATE_MUCTHUKHAC_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "SAVE_IMPORT_SUCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "SAVE_IMPORT_ERROR",
    (m) => {
      NotifyHelper.Error(m ?? "Thất bại");
    }
  ),
  ...generateActionForKey(eMucThuActionsObj, "MUC_THU", "IMPORT_SUCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eMucThuActionsObj, "MUC_THU", "IMPORT_ERROR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "IMPORT_HUYDUYET_SUCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eMucThuActionsObj,
    "MUC_THU",
    "IMPORT_HUYDUYET_ERROR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
